import React from 'react';
import {StyleSheet} from 'react-native';
import { ColorTokens, FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
import { ThemedText, ThemedView } from '@app/theme';

export interface TooltipCompProps {
    id?: string,
    bgColor?: ColorTokens,
    title?: string,
    leftShiftContent?: number,
    padding?: number,
    width?: number,
    tooltipContainerBottomPosition?: number,
    tooltipArrowBottomPosition?: number,
    tooltipArrowLeftPosition?: number,
}

const TooltipComp: React.FunctionComponent<TooltipCompProps> = ({
    title = "",
    bgColor = ColorTokens.White,
    leftShiftContent=-215,// for shifting of tooltip pointer
    padding = 16,
    width = 272,
    tooltipContainerBottomPosition = 30,
    tooltipArrowLeftPosition = 1,
    tooltipArrowBottomPosition = 22,
}) => {
    return (
        <ThemedView>
            <ThemedView style={[styles.tooltip,
                {backgroundColor:bgColor,
                transform: [{ translateX: leftShiftContent }],
                padding : padding,
                width: width,
                bottom: tooltipContainerBottomPosition
                }]}>
                <ThemedText variant='b4r' color="text-secondary">
                    {title}
                </ThemedText>
            </ThemedView>
            <ThemedView style={[styles.triangle,styles.arrowDown,{bottom:tooltipArrowBottomPosition,left:tooltipArrowLeftPosition}]}/>
        </ThemedView>
    )
}

const styles = StyleSheet.create({
    tooltip: {
        position: 'absolute',
        zIndex :999,
        borderRadius: 8,
        left: '50%',
        shadowColor: '#000000',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.17,
        shadowRadius: 17,
        elevation : 8,
    },
    triangle: {
        width: 0,
        height: 0,
        backgroundColor: 'transparent',
        borderStyle: 'solid',
        zIndex :1,
    },
    arrowDown: {
        position: 'absolute',
        borderTopWidth: 8,
        borderRightWidth: 8,
        borderBottomWidth: 0,
        borderLeftWidth: 8,
        borderTopColor: 'white',
        borderRightColor: 'transparent',
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        zIndex :1,
    },
})


export default TooltipComp;